import { render, staticRenderFns } from "./OrganizationEvents.vue?vue&type=template&id=1df3d960&scoped=true"
import script from "./OrganizationEvents.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationEvents.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationEvents.vue?vue&type=style&index=0&id=1df3d960&prod&lang=scss"
import style1 from "./OrganizationEvents.vue?vue&type=style&index=1&id=1df3d960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3d960",
  null
  
)

export default component.exports